import { useForm, type UseFormReturn } from 'react-hook-form';
import type { EditApiTokenFormValues } from './types';
import type { ApiToken } from '@/entities/api-token';

type Props = {
  apiToken: ApiToken;
};

type Params = {
  form: UseFormReturn<EditApiTokenFormValues>;
};

export const useEditApiTokenForm = ({ apiToken }: Props): Params => {
  const form = useForm<EditApiTokenFormValues>({
    mode: 'onSubmit',
    defaultValues: {
      access: apiToken.access,
      authenticationType: apiToken.authenticationType,
    },
  });

  return {
    form,
  };
};
